class ValidationError extends Error{
    public errors;
    constructor(errors: object, ...params){
        super(...params);
        this.name = "ValidationError";
        this.errors = errors;
    }
}

export default ValidationError;